import React from 'react';
import { Code2, Github, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Separator } from './ui/separator';

const Footer = () => {
  return (
    <footer className="border-t border-border bg-surface">
      <div className="container-custom py-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="space-y-3">
            <div className="flex items-center space-x-2">
              <Code2 className="h-5 w-5 text-primary" />
              <span className="font-semibold">.NET + EF Core</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Interactive training website for Entity Framework Core demonstrations.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-3 text-sm font-semibold">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-foreground transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/playground" className="text-muted-foreground hover:text-foreground transition-colors">
                  Playground
                </Link>
              </li>
            </ul>
          </div>

          {/* References */}
          <div>
            <h3 className="mb-3 text-sm font-semibold">References</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://learn.microsoft.com/en-us/ef/core/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  EF Core Docs
                </a>
              </li>
              <li>
                <a
                  href="https://dotnet.microsoft.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  .NET Platform
                </a>
              </li>
              <li>
                <a
                  href="https://learn.microsoft.com/en-us/aspnet/core/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  ASP.NET Core
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="mb-3 text-sm font-semibold">Connect</h3>
            <div className="flex space-x-3">
              <a
                href="https://github.com/siddhartha-pradhan"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="GitHub"
              >
                <Github className="h-5 w-5" />
              </a>
              <a
                href="https://www.linkedin.com/in/siddhartha-pradhan-ix/"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <Separator className="my-6" />

        <div className="flex flex-col items-center justify-between space-y-2 text-sm text-muted-foreground sm:flex-row sm:space-y-0">
          <p>© 2026 .NET with EF Core Demo. Built for educational purposes.</p>
          <p>Powered by React and Framer Motion</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
